module.exports = __webpack_public_path__ + "img/rtc-background-process.8ec04622.svg";